import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import _ from 'lodash';
import {LoginService} from '../../../services/login.service';
import {NotificationsService} from 'angular2-notifications';
import {ActivatedRoute} from '@angular/router';
import {DygraphsComponent} from '../zoomView/dygraphs/dygraphs.component';
import {ModalService} from '../../../services/modalService/modal.service';
import Dygraph from 'dygraphs';
import { TranslateService } from '@ngx-translate/core';
import { BackendTranslateService } from '../../../helper/backend-translate.service';
@Component({
  selector: 'app-license-usage',
  templateUrl: './license-usage.component.html',
  styleUrls: ['./license-usage.component.css', '../myreports.component.css']
})
export class LicenseUsageComponent implements OnInit {
  ruid: string;
  isLicense: string;
  chartData: any = [];
  options: any = {
    height: 400,
    animatedZooms: true,
    legend: 'always',
    pointSize: 4,
    axes: {
      y: {
        axisLabelFormatter: function (x) {
          return Math.round(x) == x ? x : '';
        }
      }
    }
  };
  isLoggedIn = false;
  currentUser: any;
  features: any;
  feature: any = 'All';
  dg: any;
  someRange = 100;
  sideSlideConfig = {
    step: 1,
    connect: true,
    range: {
      min: 10,
      max: 300
    },
    direction: 'rtl',
    orientation: 'vertical'
  };
  minValue: number;
  maxValue: number;

  constructor(private apiService: ApiService,
              private loginService: LoginService,
              private route: ActivatedRoute,
              private notifications: NotificationsService,
              private modalService: ModalService,
              private translate: TranslateService,
              private backendTranslate: BackendTranslateService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
        if (this.ruid === 'demo') {
          this.reportsData();
        } else {
          this.loginService.isLoggedIn()
            .subscribe((currentUser) => {
              this.currentUser = currentUser;
              this.isLoggedIn = this.currentUser.isLoggedIn;

              if (this.isLoggedIn) {
                this.apiService.getSummary(this.ruid)
                  .subscribe((res) => {
                    this.isLicense = res.isLicense;
                    if (!res.isLicense) {
                      this.reportsData();
                    }
                  }, (error) => {
                      this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.invalidRuid')));
                  });
              }
            });
        }
      }
    });
  }

    title():string {
        return 'License Usage';
    }

    reportsData() {
    this.apiService.getLicenseUsage(this.ruid)
      .subscribe((res) => {
        for (const key of Object.keys(res.featureIdAndDescription)) {
          const translations = this.backendTranslate.translateMessage(res.featureIdAndDescription[key]);
          if (translations.split('.')[0] !== 'apiMessages') {
            res.featureIdAndDescription[key] = translations;
          }
        }
        res.labels.forEach((elem, index) => {
          const translations = this.backendTranslate.translateMessage(elem);
          if (translations.split('.')[0] !== 'apiMessages') {
            res.labels[index] = translations;
          }
        });
        this.features = res.featureIdAndDescription;
        this.chartData = _.map(res.data, (innerArray) => {
          return _.map(innerArray, _.ary(parseInt, 1));
        });
        this.chartData = _.map(this.chartData, (element) => {
          element[0] = new Date(element[0]);
          return element;
        });
        this.options.labels = res.labels;
        this.options.labelsUTC = true;
        // console.log(document.getElementById('graphdiv'));
        if (document.getElementById("graphdiv")) {
          this.dg = new Dygraph(document.getElementById("graphdiv"), this.chartData, this.options);
          this.dg.ready(function () {
            this.resize();
          });
          this.updateRange(this, this.dg);
        }
      }, (error) => {
          this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.licFail')));
      });
  }

  zoomView() {
      if (this.chartData.length === 0 || this.chartData[0].length === 0) {
          return;
      }
    this.modalService.open(DygraphsComponent, {
      data: this
    }).subscribe(model => {
    });
  }

  remapDygraph($event, data, dgChart) {
    if(dgChart != this.dg){ //If executed from zoomed view, update report view too
        this.remapDygraph($event, this, this.dg);
    }

    let selector = $event.target;
    let all = selector.value == 'All';
    let allFeatures = selector.value == 'AllFeatures';
    let total = selector.value == 'Total';
    let selected = selector.selectedIndex;
    if (allFeatures) {
      selected = -1;
    }
    else if (total || all) {
      selected -= 1;
    }
    let visibility = [];
    _.forEach(dgChart.user_attrs_.labels, (value, key) => {
      visibility[key - 1] = all || allFeatures;
      if (data.feature == value) {
        visibility[key - 1] = true;
      }
    });
    if (allFeatures) {
      visibility[dgChart.numColumns() - 2] = false;
      visibility[dgChart.numColumns() - 1] = false;
    }
      dgChart.updateOptions({visibility: visibility, valueRange: null});
      data.someRange = 100;
      this.updateRange(data, dgChart);
  }

  updateRange(data, dgChart) {
    let range = dgChart.yAxisRange();
      data.minValue = range[0];
      data.maxValue = range[1];
  }

  onChange(event) {
    let max = this.maxValue * event / 100;
    this.dg.updateOptions({valueRange: [this.minValue, max]});
  }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/license-usage/license-usage.component.ts